import React from 'react';
import Stack, { StackProps } from '@mui/material/Stack';

const RowStack = ({ children, ...props }: StackProps) => {
    return (
        <Stack
            direction="row"
            alignItems="center"
            {...props}
        >
            {children}
        </Stack>
    );
};

export default RowStack;
